import Index from '@/components/monitor/Index.vue'
import Evironment from '@/components/monitor/environment/Index.vue'
import Fertilizer from '@/components/monitor/fertilizer/Index.vue'
import Sapling from '@/components/monitor/sapling/Index.vue'
import Soil from '@/components/monitor/soil/Index.vue'
import Disease from '@/components/monitor/disease/Index.vue'
import Demo from "@/components/monitor/MonitorDemo/Demo";
export default {
  path: 'monitor',
  component: Index,
  children: [
    /**
     * 环境监测
     */
    {
      path: 'evironment',
      component: Evironment
    },
    // /**
    //  * 水肥监测
    //  */
    // {
    //   path: 'fertilizer',
    //   component: Fertilizer
    // },
    /**
     * 苗情监测
     */
    {
      path: 'sapling',
      component: Sapling
    },
    /**
     * 土壤检测
     */
    {
      path: 'soil',
      component: Soil
    },
    /**
     * 病虫害监测
     */
    {
      path: 'disease',
      component: Disease
    },
    /**
     * 监控数据，独立路由
     * */
    {
      path: 'demo',
      component: Demo
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/monitor.js